










import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class Submit extends Vue {
  private get timeoutShort() {
    return this.$store.getters.timeoutShort;
  }
}
